<template>
  <div class="login">
    <div class="title">
      <h3>
        <img src="../assets/logo1.png">
        <span>综检联网平台</span>
      </h3>
      <h4>欢迎使用内蒙古自治区综检联网平台</h4>
    </div>
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="账户密码登陆" name="first">
        <div class="login-box">
          <el-input class="login-form-item"
                    placeholder="用户名"
                    v-model="userName"
          >
            <i slot="prefix">
              <img src="../assets/user1.png">
            </i>
          </el-input>


          <el-input class="login-form-item"
                    placeholder="密码" type='password'
                    v-model="userPassword"
          >
            <i slot="prefix">
              <img src="../assets/pass.png">
            </i>
          </el-input>
          <div class="login-bottom">
                        <span>
                            <el-checkbox v-model="rememberPass">记住用户</el-checkbox>
                        </span>
            <span></span>
            <a>忘记密码</a>
          </div>
          <el-button class="login-button" @click="submit" type="primary">登录</el-button>

        </div>

      </el-tab-pane>
      <el-tab-pane class="sLogin" label="扫码登陆" name="second" style="text-align:center">
        <img src="../assets/er.png" alt="">
        <p style="height:40px">
          <img src="../assets/wechat.png" alt="">
          <font>请始用微信扫码登录</font>
          <img @click="fresh" style="cursor:pointer" src="../assets/fresh.png" alt="">
          <span @click="fresh" style="cursor:pointer">刷新</span>
        </p>
      </el-tab-pane>
    </el-tabs>
    <div class="download-box">
      <span>公告管理</span>
      <ul class="content-box">
        <li v-for="item in files" :key="item.id">
          <div class="box1">
            <div class="content-left">
              <img src="../assets/pdf.png" alt="">
            </div>
            <div class="content-right">
              <div class="title-b">
                {{ item.title }}
              </div>
              <div class="article">
                {{ item.content }}
              </div>
            </div>
          </div>
          <div class="box2">
            下载
          </div>
          <div class="update-time">
            {{ item.updateTime }}
          </div>

        </li>
      </ul>
      <div class="page">
        <el-pagination
            background
            layout="prev, pager, next"
            :page-size='3'
            :total="filesAll.length"
            @current-change='changeCurrent'>
        </el-pagination>
      </div>
      <p class="copyRight">
        Copyright © 2019 综检联网平台 苏ICP备19010855号
      </p>

    </div>


  </div>
</template>

<script>
import 'axios'

export default {
  data() {
    return {
      userName: '',
      userPassword: '',
      activeName: 'first',
      rememberPass: true,
      cutNum: 0,
      pageNow: 0,
      files: [],
      filesAll: [
        {
          id: 0,
          title: '内交发 [2018] 785号文件1',
          content: '《内蒙古交通厅关于印发加快推进道路货运车辆综合性能检测联网实现普通货物运输车辆异地检车工作实施方案通知》',
          updateTime: '更新时间：2019.04.15 '
        },
        {
          id: 1,
          title: '内交发 [2018] 785号文件2',
          content: '《内蒙古交通厅关于印发加快推进道路货运车辆综合性能检测联网实现普通货物运输车辆异地检车工作实施方案通知》',
          updateTime: '更新时间：2019.04.15 '
        },
        {
          id: 2,
          title: '内交发 [2018] 785号文件3',
          content: '《内蒙古交通厅关于印发加快推进道路货运车辆综合性能检测联网实现普通货物运输车辆异地检车工作实施方案通知》',
          updateTime: '更新时间：2019.04.15 '
        },
        {
          id: 3,
          title: '内交发 [2018] 785号文件4',
          content: '《内蒙古交通厅关于印发加快推进道路货运车辆综合性能检测联网实现普通货物运输车辆异地检车工作实施方案通知》',
          updateTime: '更新时间：2019.04.15 '
        },
        {
          id: 4,
          title: '内交发 [2018] 785号文件5',
          content: '《内蒙古交通厅关于印发加快推进道路货运车辆综合性能检测联网实现普通货物运输车辆异地检车工作实施方案通知》',
          updateTime: '更新时间：2019.04.15 '
        }
      ]
    }
  },
  methods: {
    submit() {
      if (!this.userName || !this.userPassword) {
        this.$message.error('请输入正确的用户名或密码');
        return
      }
      this.$router.push({
        path: '/homePage'
      })
    },
    fresh() {

    },
    showFileList() {
      this.files = []
      let lastPgae = Math.ceil(this.filesAll.length / 3)
      let cutNum = this.pageNow == (lastPgae - 1) ? this.filesAll.length % 3 : 3
      for (var i = 0; i < cutNum; i++) {
        this.files.push(this.filesAll[this.pageNow * 3 + i])
      }
    },
    changeCurrent(e) {
      this.pageNow = e - 1
      this.showFileList()
    }

  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'background-color:rgb(240,242,245)')

  },
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style')
  },
  mounted() {
    this.showFileList()
  }
}
</script>

<style scoped lang='stylus'>
.login {
  .title {
    color #317eac
    width 480px
    font-size 30px
    margin 40px auto 0
    text-align center

    h3 {
      img {
        width 59px;
        height 59px;
        vertical-align middle
        position relative
        top -5px
      }

      span {
        font-size 33px;
        font-weight bold;
        color black
        margin-left 20px
      }

    }

    h4 {
      color rgba(0, 0, 0, 0.65)
      font-size 14px
    }
  }

  .tab-box {
    width: 416px;
    height: 309px;
    color: rgba(80, 80, 80, 1);
    border-radius: 12px;
    font-size: 14px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
    margin 20px auto
    padding 0 20px
    box-sizing border-box
    background white
  }

  .login-box {
    width 100%
    height 100%

    .el-input {
      img {
        width 16px
        position relative
        top: 16px;
        left: 6px;
      }

      .el-input--prefix .el-input__inner {
        padding-left 38px !important
      }
    }
  }

  .login-bottom {
    margin-top 12px

    a {
      float right
      color #409EFF
      cursor pointer
    }
  }

  .login-tips {
    height 50px
    text-align center
    line-height 50px
    background #d9edf7
    color #3a87ad
    border 1px solid #bce8f1
  }

  .login-button {
    width 100%
    height 40px
    margin 20px auto 0
    background #2fa4e7;
    color white
    background: rgba(24, 144, 255, 1)
  }

  .sLogin img {
    width 193px;
    height 206px
  }

  .sLogin p img {
    width 20px
    height 20px
    margin 0 3px 0 10px
    position relative
    top 5px
  }

  .download-box {
    width 1150px
    margin 30px auto
    border-top 1px solid #bbbbbb
    padding-top 10px

    span {
      color rgba(0, 0, 0, 0.85)
      font-size 16px

    }

    .content-left {
      width 64px
      float left
      height 100%
      text-align center

      img {
        width 46px
        height 46px
      }
    }

    .content-right {
      width 280px;
      float right
      height 100%

      .title-b {
        color rgba(0, 0, 0, 0.85)
        font-size 16px
        border-bottom 1px solid #eee
        height 35px
        line-height 35px
      }

      .article {
        color rgba(0, 0, 0, 0.45)
        font-size 14px
        line-height 24px
        padding-top 10px
        box-sizing border-box
      }
    }

    ul {
      margin-top 10px

      display flex
      justify-content flex-start

      li {
        position relative
        width 364px;
        height 184px
        padding 10px
        box-sizing border-box
        background white
        border-radius 6px
        margin-right 18px

        .box1 {
          height 136px
        }

        .box2 {
          height 30px
          background rgba(247, 249, 250, 1)
          text-align center
          line-height 30px
          font-size 14px
          cursor pointer
        }

        .update-time {
          position absolute
          top 3px
          right 5px
          color rgba(80, 80, 80, 1)
          font-size 10px
        }
      }
    }
    .page {
      text-align center
      margin-top 10px
    }
    .copyRight {
      color rgba(166, 166, 166, 1)
      font-size 12px
      margin 30px auto 10px
      width 300px
      text-align center
    }
  }
}


</style>
<style lang="stylus">
.login-form-item {
  margin-top 20px
}
.login-form-item, .login-form-item .el-input__inner {
  height 50px

}
</style>
